export const ALREADY_LOADED_ICON_URLS = new Map<string, SVGElement>();
